(function () {
  function initDigiInfoProdutos(section) {
    if (!section) return;
    if (!section.matches('.digi-product')) section = section.querySelector('.digi-product');
    if (!section || section.dataset.digiProductReady === 'true') return;
    section.dataset.digiProductReady = 'true';

    const form = section.querySelector('[data-digi-product-form]');
    const quantityInput = section.querySelector('[data-digi-quantity]');
    const minusButton = section.querySelector('[data-digi-qty-minus]');
    const plusButton = section.querySelector('[data-digi-qty-plus]');
    const discountOptions = section.querySelectorAll('[data-digi-discount-option]');
    const addButton = section.querySelector('[data-digi-add-button]');
    const formMessage = section.querySelector('[data-digi-form-message]');
    const cepInput = section.querySelector('[data-digi-cep]');
    const shippingButton = section.querySelector('[data-digi-shipping-button]');
    const shippingMessage = section.querySelector('[data-digi-shipping-message]');
    const upsellButtons = section.querySelectorAll('[data-upsell-add]');

    const oneTimeInput = section.querySelector('[data-digi-variant-id]');
    const oneTimeVariantId = oneTimeInput?.dataset.oneTimeVariantId || '';
    const oneTimeAvailable = oneTimeInput?.dataset.oneTimeAvailable === 'true';
    const isCombo = oneTimeInput?.dataset.productMode === 'combo';
    const comboReady = oneTimeInput?.dataset.comboReady === 'true';
    let comboItems = [];
    if (isCombo) {
      try { comboItems = JSON.parse(section.querySelector('[data-digi-combo-items]')?.textContent || '[]'); } catch {}
    }
    const comboPrice = Number(oneTimeInput?.dataset.comboPrice || 0);
    const comboSubtotal = Number(oneTimeInput?.dataset.comboSubtotal || 0);
    const comboKey = oneTimeInput?.dataset.comboKey || '';
    const canBuy = oneTimeAvailable && (!isCombo || (comboReady && comboItems.length > 0 &&
      comboItems.every(item => item.available && /^[0-9]+$/.test(String(item.id))) &&
      comboPrice > 0 && comboSubtotal >= comboPrice));
    if (isCombo && addButton) {
      addButton.disabled = !canBuy;
      if (!canBuy && oneTimeAvailable) {
        const label = addButton.querySelector('.digi-product__add-label');
        if (label) label.textContent = 'EM CONFIGURAÇÃO';
      }
    }
    const upsellVariants = new Map(Array.from(upsellButtons, button => [button, {
      id: button.dataset.oneTimeVariantId || '',
      available: button.dataset.oneTimeAvailable === 'true'
    }]));

    function setQuantity(value) {
      if (!quantityInput) return;

      const parsedValue = parseInt(value, 10);
      quantityInput.value = Number.isNaN(parsedValue) || parsedValue < 1 ? 1 : parsedValue;
    }

    function updateSelectedDiscount(selectedInput) {
      discountOptions.forEach((input) => {
        const option = input.closest('.digi-product__discount-option');
        if (!option) return;

        option.classList.toggle('is-selected', input === selectedInput);
      });

      setQuantity(selectedInput.value);
    }

    if (minusButton) {
      minusButton.addEventListener('click', function () {
        setQuantity(parseInt(quantityInput.value || '1', 10) - 1);
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function () {
        setQuantity(parseInt(quantityInput.value || '1', 10) + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        setQuantity(quantityInput.value);
      });
    }

    discountOptions.forEach((input) => {
      input.addEventListener('change', function () {
        updateSelectedDiscount(input);
      });
    });

    function openCartDrawer() {
      const selectors = [
        '[data-open-cart-sidebar]',
        '[data-cart-toggle]',
        '.cart-toggle',
        '.header__icon--cart'
      ];

      for (let sel of selectors) {
        const btn = document.querySelector(sel);
        if (btn) {
          btn.click();
          return;
        }
      }

      // fallback
      document.body.classList.add('open-cart-sidebar');
    }

    if (addButton?.classList.contains('is-loading')) return;

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!addButton || addButton.classList.contains('is-loading')) return;
        if (!canBuy || !/^[0-9]+$/.test(oneTimeVariantId)) {
          if (formMessage) formMessage.textContent = 'Compra única indisponível para este produto.';
          return;
        }

        const label = addButton.querySelector('.digi-product__add-label');
        const defaultText = label ? label.textContent : '';

        setQuantity(quantityInput?.value || '1');
        const cartItem = {
          id: oneTimeVariantId,
          quantity: Number(quantityInput?.value || 1)
        };

        let items = [cartItem];
        if (isCombo) {
          items = [];
          const discountBRL = (comboSubtotal - comboPrice) / 100;
          for (let bundleIndex = 0; bundleIndex < cartItem.quantity; bundleIndex += 1) {
            const bundleId = 'pdp-' + crypto.randomUUID();
            comboItems.forEach(item => items.push({
              id: item.id,
              quantity: 1,
              properties: {
                _bundleId: bundleId,
                _bundleKey: comboKey,
                _bundleVersion: 'fixed-pack-v1',
                _bundleRole: 'child',
                _bundleParentVariantId: oneTimeVariantId,
                _bundleDiscountType: 'fixed_amount',
                _bundleDiscountValue: String(discountBRL)
              }
            }));
          }
        }

        // 🔥 loading instantâneo
        addButton.classList.add('is-loading');
        addButton.disabled = true;

        if (label) label.textContent = 'ADICIONANDO...';

        // 🔥 abre drawer IMEDIATO (igual vitrine)
        openCartDrawer();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: JSON.stringify({ items }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }
            return response.json();
          })
          .then(() => {
            if (typeof Shopify !== 'undefined' && Shopify.getCart) {
              Shopify.getCart(function (cart) {
                if (typeof window.updateCart === 'function') {
                  window.updateCart(cart);
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
            if (formMessage) formMessage.textContent = error.description || error.message || 'Não foi possível adicionar. Tente novamente.';
          })
          .finally(() => {
            addButton.classList.remove('is-loading');
            addButton.disabled = !canBuy;

            if (label) label.textContent = defaultText;
          });
      });
    }

    /* =========================
      GALERIA CARROSSEL
    ========================= */

    const track = section.querySelector('[data-digi-gallery-track]');
    const dots = section.querySelectorAll('[data-digi-dot]');
    const thumbs = section.querySelectorAll('[data-digi-thumb]');
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    const isStackedGallery =
      isDesktop && section.classList.contains('digi-product--gallery-stacked') &&
      !section.classList.contains('digi-product--marketplace');
    let currentSlide = 0;

    if (track && !isStackedGallery) {
      const slides = track.querySelectorAll('.digi-product__gallery-slide');

      function updateUI(index) {

        dots.forEach((dot) => {
          dot.classList.remove('is-active');
        });

        thumbs.forEach((thumb) => {
          thumb.classList.remove('is-active');
          thumb.setAttribute('aria-pressed', 'false');
        });

        if (dots[index]) {
          dots[index].classList.add('is-active');
        }

        if (thumbs[index]) {
          thumbs[index].classList.add('is-active');
          thumbs[index].setAttribute('aria-pressed', 'true');
          const rail = thumbs[index].parentElement;
          if (window.matchMedia('(min-width: 990px)').matches) {
            rail.scrollTo({ top: thumbs[index].offsetTop - rail.offsetTop - (rail.clientHeight - thumbs[index].clientHeight) / 2, behavior: 'smooth' });
          } else {
            rail.scrollTo({ left: thumbs[index].offsetLeft - rail.offsetLeft - (rail.clientWidth - thumbs[index].clientWidth) / 2, behavior: 'smooth' });
          }
        }
      }

      function goToSlide(index) {
        if (index < 0) index = 0;
        if (index > slides.length - 1) index = slides.length - 1;

        currentSlide = index;
        track.style.transform = 'translate3d(-' + (index * 100) + '%, 0, 0)';
        updateUI(index);
      }

      // clique nas bolinhas
      dots.forEach((dot) => {
        dot.addEventListener('click', function () {
          const index = parseInt(dot.dataset.index);
          goToSlide(index);
        });
      });

      /* 🔥 ADICIONA AQUI */
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', function () {
          const index = parseInt(thumb.dataset.index);
          goToSlide(index);
        });
      });

      // swipe
      let startX = 0;

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      track.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (diff > 50 && currentSlide < slides.length - 1) {
          goToSlide(currentSlide + 1);
        }

        if (diff < -50 && currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      });
    }

    upsellButtons.forEach((button) => {

      button.addEventListener('click', function () {
        if (button.disabled) return;

        if (button.classList.contains('is-loading')) return;

        const oneTime = upsellVariants.get(button);
        if (!oneTime?.available || !/^[0-9]+$/.test(oneTime.id)) return;
        const variantId = oneTime.id;

        const label = button.querySelector('.digi-product__upsell-label');

        const defaultText = label ? label.textContent : '';

        button.classList.add('is-loading');
        button.disabled = true;

        if (label) {
          label.textContent = 'ADICIONANDO...';
        }

        openCartDrawer();

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }

            return response.json();
          })
          .then(() => {

            if (typeof Shopify !== 'undefined' && Shopify.getCart) {

              Shopify.getCart(function (cart) {

                if (typeof window.updateCart === 'function') {
                  window.updateCart(cart);
                }

              });

            }

          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {

            button.classList.remove('is-loading');
            button.disabled = false;

            if (label) {
              label.textContent = defaultText;
            }

          });

      });

    });

  }

  function initAllDigiInfoProdutos() {
    document.querySelectorAll('.digi-product').forEach(initDigiInfoProdutos);
  }

  document.addEventListener('DOMContentLoaded', initAllDigiInfoProdutos);

  document.addEventListener('shopify:section:load', function (event) {
    initDigiInfoProdutos(event.target);
  });

  const flavorsLists = document.querySelectorAll('.digi-product__flavors-list');

  flavorsLists.forEach((list) => {

    let isDown = false;
    let startX;
    let scrollLeft;
    let moved = false;

    list.addEventListener('mousedown', (e) => {

      isDown = true;
      moved = false;

      list.classList.add('is-dragging');

      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;

    });

    list.addEventListener('mouseleave', () => {

      isDown = false;
      list.classList.remove('is-dragging');

    });

    list.addEventListener('mouseup', () => {

      isDown = false;

      requestAnimationFrame(() => {
        moved = false;
      });

      list.classList.remove('is-dragging');

    });

    list.addEventListener('mousemove', (e) => {

      if (!isDown) return;

      const x = e.pageX - list.offsetLeft;
      const walk = x - startX;

      // só considera drag se moveu mesmo
      if (Math.abs(walk) > 6) {
        moved = true;
      }

      if (!moved) return;

      e.preventDefault();

      list.scrollLeft = scrollLeft - (walk * 1.2);

    });

    list.querySelectorAll('a').forEach((link) => {

      link.addEventListener('click', (e) => {

        if (moved) {
          e.preventDefault();
        }

      });

    });

  });
})();
